'use client';

import { Crumb } from '@/components/breadcrumbs';
import client from '@/tina/__generated__/client';
import { useTina } from 'tinacms/dist/react';
import { BlogPostServer } from './blogPostServer';
import { BlogPostByBreadcrumbsQuery, GlobalsQuery } from '../../../lib/tinaQueries';
type BlogPostClientProps = {
  breadcrumbs: Crumb[];
  blogPost: BlogPostByBreadcrumbsQuery;
  globals: GlobalsQuery;
};
export function BlogPostClient({
  blogPost,
  breadcrumbs,
  globals
}: BlogPostClientProps) {
  const clientData = useTina({
    query: blogPost.query,
    variables: blogPost.variables,
    data: blogPost.data
  });
  return <BlogPostServer blogPostData={clientData.data} breadcrumbs={breadcrumbs} globalsData={globals.data} />;
}